import React from 'react';
import { Link } from 'gatsby';

import { H3, Paragraph } from '../components/StyledComponents/TextStyles';

export default function PostPreview({ title, node, isLast }) {
	// const isDraft = !node.frontmatter.published;

	return (
		<article className={isLast ? `` : `pb-6 sm:pb-8`}>
			<header className="pb-2">
				<H3 customClass="flex items-center mb-0 leading-snug">
					<Link
						to={node.fields.slug}
						style={{ color: 'var(--color-secondary)' }}
					>
						{title}
					</Link>
				</H3>
				<div
					className="date text-xs sm:text-sm"
					style={{ color: 'var(--color-gray-600)' }}
				>
					<time dateTime={new Date(node.frontmatter.date)}>
						{node.frontmatter.date}
					</time>
				</div>
			</header>
			<section>
				<Paragraph
					customClass="text-sm md:text-base"
					dangerouslySetInnerHTML={{
						__html: node.frontmatter.description || node.excerpt,
					}}
					style={{ color: 'var(--color-gray-800)' }}
				/>
			</section>
		</article>
	);
}
